import { restApi } from '../../api/restApiSlice';

export const renderingQueueApi = restApi.injectEndpoints({
  endpoints: (builder) => ({
    clearManualQueue: builder.mutation({
      query: () => ({ url: '/v3/render-queue/manual', method: 'DELETE' }),
      providesTags: ['ManualQueue'],
    }),
  }),
});

export const { useClearManualQueueMutation } = renderingQueueApi;
